/**
 * Sichtlinien-Pruefung auf dem Tile-Raster: eine gerade Strecke wird in festen
 * Schritten abgetastet und jeder Punkt gegen ein Praedikat geprueft. Reine
 * Funktion ohne Pixi/DOM.
 *
 * Zwei Nutzer mit unterschiedlichem Praedikat: die Pfad-Glaettung des
 * Klick-zum-Laufen (blockiert = Wand oder gesperrte Zone) und spaeter die
 * Verdeckungspruefung der Video-Bubbles (blockiert = nur Wand). Deutlich
 * billiger als ein echter 3D-Raycast.
 */

/** Abtastschritt in Tiles — feiner als der Kollisionsradius von 0,35. */
export const LOS_SAMPLE_STEP_TILES = 0.25;

/**
 * Prueft die Strecke zwischen zwei Tiles. `ax`/`ay` und `bx`/`by` sind
 * Tile-Indizes; abgetastet wird zwischen den Tile-Mittelpunkten.
 */
export function isSegmentClear(
  ax: number,
  ay: number,
  bx: number,
  by: number,
  isPassable: (x: number, y: number) => boolean,
): boolean {
  const steps = Math.ceil(Math.hypot(bx - ax, by - ay) / LOS_SAMPLE_STEP_TILES);
  for (let i = 0; i <= steps; i += 1) {
    const t = steps === 0 ? 0 : i / steps;
    if (!isPassable(ax + 0.5 + (bx - ax) * t, ay + 0.5 + (by - ay) * t)) return false;
  }
  return true;
}
